import React from "react";
import ReactDOM from "react-dom/client";
import "rc-slider/assets/index.css";
import '@mantine/core/styles.css';
// STYLE
import "./styles/index.scss";
import "./index.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-datepicker/dist/react-datepicker.css"; 
import { initSentry } from "utils/sentry";
import "react-toastify/dist/ReactToastify.css"; // ← add this
import ReactGA from "react-ga4";

// FB/IG Android WebView redirect — open in system browser instead
// Rollback: remove this block
(function() {
  try {
    var ua = navigator.userAgent || '';
    var isFBIAB = /FBAN|FBAV|Instagram/i.test(ua);
    if (isFBIAB) {
      var url = window.location.href;
      var intentUrl = 'intent://' + url.replace(/^https?:\/\//, '') + '#Intent;scheme=https;package=com.android.chrome;end';
      window.location.replace(intentUrl);
    }
  } catch(e) {}
})();

initSentry();

if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
reportWebVitals();
